import { useState, type FormEvent } from "react";
import { api, ApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdminUsersPage() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState<"viewer" | "admin">("viewer");
  const [message, setMessage] = useState<{ kind: "ok" | "err"; text: string } | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      await api.createUser(email, role, name || undefined);
      setMessage({ kind: "ok", text: `${email} にマジックリンクを送信しました` });
      setEmail("");
      setName("");
    } catch (err) {
      setMessage({ kind: "err", text: err instanceof ApiError ? err.message : "失敗しました" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-md space-y-6">
      <h1 className="text-2xl font-semibold">ユーザー追加</h1>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email">メールアドレス</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="name">名前(任意)</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="role">権限</Label>
          <select
            id="role"
            value={role}
            onChange={(e) => setRole(e.target.value as "viewer" | "admin")}
            className="h-9 w-full rounded-md border border-input bg-background px-2 text-sm"
          >
            <option value="viewer">viewer</option>
            <option value="admin">admin</option>
          </select>
        </div>
        {message && (
          <p className={message.kind === "ok" ? "text-sm text-green-700" : "text-sm text-destructive"}>{message.text}</p>
        )}
        <Button type="submit" disabled={loading}>{loading ? "送信中…" : "ユーザーを追加"}</Button>
      </form>
    </div>
  );
}
